import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui"; //全局引入element
import "element-ui/lib/theme-chalk/index.css"; //全局引入element css
import "@/styles/index.less"; // 全局 css
import VueClipBoard from "vue-clipboard2"; //复制
import base from "./utils/base";
import Vant from "vant";
// 2. 引入组件样式
import "vant/lib/index.css";
import InfiniteLoading from "vue-infinite-loading";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueClipBoard);
Vue.use(Vant);
Vue.use(InfiniteLoading);
Vue.prototype.$base = base; //全局方法
Vue.prototype.$imgapi = "https://edu0109.edochxun.com/"; //全局方法
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js